import { z } from 'zod';
import superjson from 'superjson';
import { Json } from '../../helpers/schema';

export const schema = z.object({
  sessionId: z.string().min(1),
  attachmentId: z.string().optional(),
  checkpointId: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type AnnotationUser = {
  id: number;
  displayName: string;
  avatarUrl: string | null;
};

export type AnnotationItem = {
  id: string;
  annotationData: Json;
  description: string | null;
  attachmentId: string | null;
  checkpointId: string | null;
  createdAt: Date | string | null;
  sessionId: string;
  createdBy: AnnotationUser;
};

export type OutputType = {
  annotations: AnnotationItem[];
};

export const getAnnotationsList = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams();
  params.append('sessionId', input.sessionId);
  if (input.attachmentId) params.append('attachmentId', input.attachmentId);
  if (input.checkpointId) params.append('checkpointId', input.checkpointId);

  const result = await fetch(`/_api/annotations/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
